<template>
  <div class="vg_wrapper">
    <el-card>
      <div class="flexV vg_mb_8">
        <div class="vg_ml_8 vg_mr_8">
          要求交货日期:
          <el-date-picker
            v-model="dateRange"
            class=""
            end-placeholder="结束日期"
            range-separator="至"
            size="small"
            start-placeholder="开始日期"
            type="daterange"
            value-format="timestamp"
          />
        </div>
        <div class="vg_ml_8 vg_mr_8">
          合同日期:
          <el-date-picker
            v-model="dateRange2"
            end-placeholder="结束日期"
            range-separator="至"
            size="small"
            start-placeholder="开始日期"
            type="daterange"
            value-format="timestamp"
          />
        </div>
        <el-button icon="el-icon-search" size="small" type="primary" @click="getDataList()"> 查询</el-button>
        <el-button icon="el-icon-refresh-right" size="small" type="info" @click="buttonRefresh()"> 刷新</el-button>
      </div>
      <DynamicUTable
        ref="multiTable"
        v-loading="loadFlag"
        :columns="tableProperties"
        :need-check-box="false"
        :need-fixed-height="true"
        :need-page-sizes="true"
        :need-search="true"
        :needRemoteTotalSums="true"
        :page-size="50"
        :show-summary="true"
        :special-header-height="'70px'"
        :summaryTotal="summaryTotal"
        :table-data="tableData"
        :totalPage="totalPage"
        @getTableData="getDataList"
        @row-dblclick="dbClickJp"
      >
        <template v-slot:status="scope">
          <div style="text-align: center">
            <el-tag :type="helper.getStatusName(scope.row.status).type" size="mini">
              {{ helper.getStatusName(scope.row.status).name }}
            </el-tag>
          </div>
        </template>
      </DynamicUTable>
    </el-card>
  </div>
</template>

<script>
import UrlEncode from '@assets/js/UrlEncode';
import { cloneDeep } from 'lodash';
import DynamicUTable from '@/components/table/DynamicUTable.vue';
import SearchTable from '@/components/table/SearchTableV2.vue';
import { tableProperties } from '@/views/PurcManagement/FinishedProductAndMaterialOrder/js/properties';
import { api } from '@/views/PurcManagement/FinishedProductAndMaterialOrder/js/api';

export default {
  name: 'FinishedProductAndMaterialOrderList',
  components: {
    SearchTable,
    DynamicUTable
  },
  data() {
    return {
      tableProperties: cloneDeep(tableProperties),
      tableData: [],
      totalPage: 0,
      btn: {},
      loadFlag: true,
      dateRange: [],
      dateRange2: [],
      summaryTotal: {},
      type: '进口物料'
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      await this.getDataList();
    },
    async getDataList() {
      this.loadFlag = true;
      let searchForm = cloneDeep(this.$refs.multiTable.searchForm);
      searchForm.source_attribute = this.type;
      this.setTime(searchForm, 'startTime', 'endTime', this.dateRange || [], false);
      this.setTime(searchForm, 'startTime2', 'endTime2', this.dateRange2 || [], false);
      api.get_rmaterial_orders(searchForm).then(({ data }) => {
        this.tableData = data.list;
        this.totalPage = data.total;
        this.summaryTotal = data.mapSum;
        this.btn = data.btn;
        this.loadFlag = false;
      });
    },
    // 刷新
    buttonRefresh() {
      this.dateRange = [];
      this.dateRange2 = [];
      this.$refs.multiTable.resetFields();
      this.getDataList();
    },
    // 双击row跳转到详情编辑
    dbClickJp(row) {
      this.jump('/purmaterial_orders_edit', {
        key: UrlEncode.encode(
          JSON.stringify({
            perm_id: this.$route.query.perm_id,
            form_id: row.purmaterial_orders_id
          })
        )
      });
    },
    setTime(searchForm, startTimeKey, endTimeKey, dateRange = [], convertToSeconds = true) {
      const [startTime, endTime] = dateRange || [];
      // 确保时间戳被正确赋值且进行单位转换（如果需要）
      searchForm[startTimeKey] = startTime ? Math.floor(convertToSeconds ? startTime / 1000 : startTime) : null;
      searchForm[endTimeKey] = endTime ? Math.floor(convertToSeconds ? endTime / 1000 : endTime) : null;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__content {
  padding: 0 !important;
}
.dateClass {
  display: flex;
  align-items: baseline;
  flex-direction: column;
  width: 280px;
}
</style>
